import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { toLower, defaultTo } from 'ramda'

const ExperienceControls = ({ id, type, status, onStatusUpdate }) => (
  <div className='br-experience-controls pull-right'>
    <Link
      to={`/experiences/${toLower(defaultTo('MENTION', type))}/${id}/edit`}
      className='btn btn-icon btn-sm green-haze'
      title='Edit'
    >
      <i className='fa fa-wrench' />
    </Link>
    &nbsp;
    {status.toLowerCase() === 'draft' && (
      <button
        className='btn btn-icon btn-sm green-haze'
        onClick={() => {
          onStatusUpdate({ id, status: 'active' })
        }}
        title='Start'
      >
        <i className='fa fa-power-off' />
      </button>
    )}
    {status.toLowerCase() === 'active' && (
      <button
        className='btn btn-icon btn-sm green-haze'
        onClick={() => {
          onStatusUpdate({ id, status: 'paused' })
        }}
        title='Pause'
      >
        <i className='fa fa-pause' />
      </button>
    )}
    {status.toLowerCase() === 'paused' && (
      <button
        className='btn btn-icon btn-sm green-haze'
        onClick={() => {
          onStatusUpdate({ id, status: 'active' })
        }}
        title='Resume'
      >
        <i className='fa fa-play' />
      </button>
    )}
    &nbsp;
    <button className='btn btn-icon btn-sm green-haze' disabled title='Delete'>
      <i className='fa fa-trash' />
    </button>
  </div>
)

ExperienceControls.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  onStatusUpdate: PropTypes.func
}

ExperienceControls.displayName = 'ExperienceControlsComponent'

export default ExperienceControls



// WEBPACK FOOTER //
// ./src/pages/my-experiences/experience/experience-controls/index.js